import React from 'react';
import style from './index.module.scss';
import logo_url from './logo-white-desktop.svg';
import logo_url_color from './logo-color-desktop.svg';
import clsx from 'clsx';

const Block = ({ menu, isHomeMenuTop, hideMenu }) => {
    return (
        <div className={style.block}>
            <a href="/">
                <img src={isHomeMenuTop ? logo_url : logo_url_color} alt="Logo cadeaux privés" className={style.logo} />
            </a>

            { !hideMenu &&
                <ul className={clsx(style.menu, isHomeMenuTop && style.menuHome)}>
                    {Object.values(menu).map((item) => (
                        <li key={item.ID} className={clsx(item.children.length > 0 && style.hasChildren)}>
                            <a href={item.url}>{item.title}</a>

                            {item.children.length > 0 && (
                                <ul className={style.submenu}>
                                    {item.children.map((child) => (
                                        <li key={child.url}>
                                            <a href={child.url}>{child.title}</a>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </li>
                    ))}
                </ul>
            }
        </div>
    );
};
export default Block;
